// TTS (音声読み上げ) 設定管理
// - TVDisplay: デフォルトON
// - スマホ (Game): デフォルトOFF

const STORAGE_KEY = 'five_league_tts_enabled';

// 初期値を取得（デバイスタイプを考慮）
function getInitialEnabled(isTV = false) {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null) {
    return stored === 'true';
  }
  // 未設定の場合: TVはON、スマホはOFF
  return isTV;
}

// 現在の設定を取得
export function isTTSEnabled() {
  const stored = localStorage.getItem(STORAGE_KEY);
  // 明示的に設定されていない場合は null を返す（呼び出し側でデフォルト判定）
  if (stored === null) return null;
  return stored === 'true';
}

// 設定を保存
export function setTTSEnabled(enabled) {
  localStorage.setItem(STORAGE_KEY, String(enabled));
}

// TVモードかどうかを判定（画面サイズベース）
export function isTVMode() {
  if (typeof window === 'undefined') return false;
  // 横幅1024px以上をTVモードとみなす
  return window.innerWidth >= 1024;
}

// デフォルト値を取得（デバイスに応じて）
export function getDefaultTTSEnabled() {
  return isTVMode();
}

// 初期化済みかどうか（ユーザーが明示的に選択したか）
export function hasTTSPreference() {
  return localStorage.getItem(STORAGE_KEY) !== null;
}

// 設定をクリア
export function clearTTSPreference() {
  localStorage.removeItem(STORAGE_KEY);
}
